import muster from '@dbk-legacy/muster';
//import $ from 'npm-zepto';
import { getValues } from '@dbk-legacy/muster/utils';
import { variable } from '@dbk-legacy/muster/helpers';
import isValidJsonString from '../../../utils/is-valid-json-string';
import { DOCSIGN_API_ERROR_CODES, DOCSIGN_CONSTANTS } from '../../../constants';
import Guid from '../../../utils/guid';
import { DOCSIGN_PATH, ERROR } from './docsign-muster-constants';
import PdfDownload from '../../../utils/attachment-download';

export default () => {
  return muster()
    .path('docusignaccept.getDocuSignWebURL', {
      call: async ({ req }, { get, set }) => {
        const documentId = req.args[0];
        const inputs = `${documentId}#@#`;
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        const [result] = await getValues(get(`${DOCSIGN_PATH}.getDocuSignWebURL["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (getDocuSignURLResponse) => {
          if (getDocuSignURLResponse) {
            if (getDocuSignURLResponse.$type || getDocuSignURLResponse.messageType === ERROR) {
              await set('docusignaccept.docuSignURLResponse', getDocuSignURLResponse);
              await set('docusignaccept.docuSignURLResponseError', messages['app.digisign.error.tryagain']);
              return;
            }
            if (getDocuSignURLResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || getDocuSignURLResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docusignaccept.docuSignURLResponse', getDocuSignURLResponse);
              await set('docusignaccept.docuSignURLResponseError', '');
              await set('docusignaccept.signAction', '');
            } else if (getDocuSignURLResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || getDocuSignURLResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('docusignaccept.docuSignURLResponse', getDocuSignURLResponse);
              await set('docusignaccept.docuSignURLResponseError', messages['app.docsign.nodata.response']);
            } else if (getDocuSignURLResponse.returnCode === DOCSIGN_API_ERROR_CODES.DOCUSIGN_ENVELOPEID_FAILED_INT || getDocuSignURLResponse.returnCode === DOCSIGN_API_ERROR_CODES.DOCUSIGN_ENVELOPEID_FAILED) {
              await set('docusignaccept.docuSignURLResponse', getDocuSignURLResponse);
              await set('docusignaccept.docuSignURLResponseError', messages['app.digisign.error.tryagain']);
            } else {
              await set('docusignaccept.docuSignURLResponse', getDocuSignURLResponse);
              await set('docusignaccept.docuSignURLResponseError', messages['app.digisign.error.tryagain']);
            }
          } else {
            await set('docusignaccept.docuSignURLResponse', getDocuSignURLResponse);
            await set('docusignaccept.docuSignURLResponseError', messages['app.digisign.error.tryagain']);
          }
        }).catch(async (getDocuSignURLResponse) => {
          await set('docusignaccept.docuSignURLResponse', getDocuSignURLResponse);
          await set('docusignaccept.docuSignURLResponseError', messages['app.digisign.error.tryagain']);
        });
      }
    })

    .path('docusignaccept.completeDocumentSign', {
      call: async ({ req }, { get, set, call }) => {
        const txId = req.args[0];
        const action = req.args[1];
        const documentName = req.args[2];
        const comment = req.args[3];
        let inputs;
        if (comment) {
          inputs = `${txId}#@#${action}#@#${comment}`;
        } else {
          inputs = `${txId}#@#${action}`;
        }
        await set('docusignaccept.documentName', documentName);
        await set('docusignaccept.signAction', action);
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));
        const [result] = await getValues(get(`${DOCSIGN_PATH}.completeDocumentSign["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (completeDocumentSignResponse) => {
          if (completeDocumentSignResponse) {
            if (completeDocumentSignResponse.$type || completeDocumentSignResponse.messageType === ERROR) {
              await set('docusignaccept.completeDocumentSignResponseSuccess', true);
              await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
              await set('docusignaccept.completeDocumentSignResponseError', messages['app.digisign.error.tryagain']);
              return;
            }
            if (completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
              if (completeDocumentSignResponse.data && completeDocumentSignResponse.data.status.toLowerCase() === DOCSIGN_CONSTANTS.SUCCESS_RESPONSE) {
                if (action !== DOCSIGN_CONSTANTS.DOCUSIGN_CANCEL) {
                  await set('docusignaccept.completeDocumentSignResponseSuccess', true);
                  //await set('docusignaccept.showDocusignModal', false);
                  await set('docusignaccept.completeDocumentSignResponseError', '');
                } else {
                  //await set('docusignaccept.showDocusignModal', false);
                  await set('docusignaccept.completeDocumentSignResponseError', '');
                }
              }
            } else if (completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.REJECT_COMMENT_REQ_INT || completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.REJECT_COMMENT_REQ) {
              await set('docusignaccept.completeDocumentSignResponseSuccess', true);
              await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
              await set('docusignaccept.completeDocumentSignResponseError', completeDocumentSignResponse.message);
            } else if (completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.DOCUSIGN_API_ERROR_INT || completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.DOCUSIGN_API_ERROR) {
              await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
              await set('docusignaccept.completeDocumentSignResponseError', messages['app.digisign.error.tryagain']);
            } else if (completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || completeDocumentSignResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('docusignaccept.completeDocumentSignResponseSuccess', true);
              await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
              await set('docusignaccept.completeDocumentSignResponseError', messages['app.docsign.nodata.response']);
            } else {
              await set('docusignaccept.completeDocumentSignResponseSuccess', true);
              await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
              await set('docusignaccept.completeDocumentSignResponseError', messages['app.digisign.error.tryagain']);
            }
          } else {
            await set('docusignaccept.completeDocumentSignResponseSuccess', true);
            await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
            await set('docusignaccept.completeDocumentSignResponseError', messages['app.digisign.error.tryagain']);
          }
        }).catch(async (completeDocumentSignResponse) => {
          await set('docusignaccept.completeDocumentSignResponse', completeDocumentSignResponse);
          await set('docusignaccept.completeDocumentSignResponseError', messages['app.digisign.error.tryagain']);
        });
      }
    })

    .path('docusignaccept.getSignedDocument', {
      call: async ({ req }, { get, set }) => {
        const documentId = req.args[0];
        const inputs = `${documentId}#@#`;
        const guidStr = Guid();
        const [messages] = await getValues(get('i18n.messages'));

        await set('app.user.cacheId', Date.now());

        // Bypassing Falcor implementation for viewSignedDoc API call

        // var [envitronmentUrl, apiversion, defaultEnvironment] = await getValues(
        //   get([
        //     'settings.currentEnvironment.remoteUrl',
        //     'app.config.apiverion',
        //     'settings.defaultEnvironment'
        //   ])
        // );
        // const [authHeader] = await getValues(get(['auth.authHeader']));
        // const [userId] = await getValues(get(['auth.userId']));
        // let docUrl;

        // if (defaultEnvironment === "local" || defaultEnvironment === "static") {
        //   // Testing APAC DEV
        //   docUrl = "https://pwpbod01.sg.db.com:8243/digisign/1.0/viewSignedDoc"
        // } else {
        //   docUrl = envitronmentUrl + '/digisign/' + apiversion + '/viewSignedDoc';
        // }

        // var body = {
        //   userId: userId,
        //   branchCode: '1',
        //   documentId: documentId
        // }

        // try {
        //   $.ajax({
        //     type: 'POST',
        //     url: docUrl,
        //     headers: {
        //       'Accept': 'application/json',
        //       'Content-Type': 'application/json',
        //       'Authorization-Token': authHeader,
        //       // Enable for LOCAL Testing
        //       // 'Authorization': 'Bearer 301df1cb335808eb59f4461c21f6a021',
        //     },
        //     dataType: 'json',
        //     contentType: 'application/json',
        //     data: JSON.stringify(body),
        //     success: async function (result) {
        //       isValidJsonString(result).then(async (getSignedDocumentResponse) => {
        //         if (getSignedDocumentResponse) {
        //           if (getSignedDocumentResponse.$type || getSignedDocumentResponse.messageType === ERROR) {
        //             await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //             await set('docusignaccept.signedDocumentResponseError', messages['app.docsign.middlelayer.error']);
        //             return;
        //           }
        //           if (getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
        //             await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //             await set('docusignaccept.signedDocumentResponseError', '');

        //             // PdfDownload('document', getSignedDocumentResponse.data.base64data);
        //             PdfDownload('document', getSignedDocumentResponse.data);
        //             await set('docsign.showAcceptSignModal', false);

        //           } else if (getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
        //             await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //             await set('docusignaccept.signedDocumentResponseError', messages['app.docsign.nodata.response']);
        //           } else {
        //             await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //             await set('docusignaccept.signedDocumentResponseError', messages['app.docsign.error.response']);
        //           }
        //         } else {
        //           await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //           await set('docusignaccept.signedDocumentResponseError', messages['app.docsign.error.response']);
        //         }
        //       }).catch(async (getSignedDocumentResponse) => {
        //         await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //         await set('docusignaccept.signedDocumentResponseError', messages['app.docsign.error.response']);
        //       });
        //     }.bind(this),
        //     error: async function (request, status, getSignedDocumentResponse) {
        //       await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //       await set('docusignaccept.signedDocumentResponseError', messages['app.docsign.error.response']);
        //     }.bind(this)
        //   });
        // } catch (getSignedDocumentResponse) {
        //   await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
        //   await set('docusignaccept.signedDocumentResponseError', messages['app.docsign.error.response']);
        // }

        // Going through Falcor implementation for viewSignedDoc API call

        const [result] = await getValues(get(`${DOCSIGN_PATH}.getSignedDocument["${inputs}"]["${guidStr}"]`));
        isValidJsonString(result).then(async (getSignedDocumentResponse) => {
          if (getSignedDocumentResponse) {
            if (getSignedDocumentResponse.$type || getSignedDocumentResponse.messageType === ERROR) {
              await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
              await set('docusignaccept.signedDocumentResponseError', messages['app.digisign.error.tryagain']);
              return;
            }
            if (getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS_INT || getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.SUCCESS) {
              await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
              await set('docusignaccept.signedDocumentResponseError', '');

              // PdfDownload('document', getSignedDocumentResponse.data.base64data);
              PdfDownload('document', getSignedDocumentResponse.data);
              await set('docsign.showAcceptSignModal', false);

            } else if (getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA_INT || getSignedDocumentResponse.returnCode === DOCSIGN_API_ERROR_CODES.NO_DOCSIGN_DATA) {
              await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
              await set('docusignaccept.signedDocumentResponseError', messages['app.digisign.error.tryagain']);
            } else {
              await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
              await set('docusignaccept.signedDocumentResponseError', messages['app.digisign.error.tryagain']);
            }
          } else {
            await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
            await set('docusignaccept.signedDocumentResponseError', messages['app.digisign.error.tryagain']);
          }
        }).catch(async (getSignedDocumentResponse) => {
          await set('docusignaccept.signedDocumentResponse', getSignedDocumentResponse);
          await set('docusignaccept.signedDocumentResponseError', messages['app.digisign.error.tryagain']);
        });
      }
    })

    .path('docusignaccept.resetCompleteDocusignResponseSuccess', {
      call: async ({ req }, { set }) => {
        await set('docusignaccept.completeDocumentSignResponseSuccess', false);
        await set('docusignaccept.documentName', '');
      }
    })

    .path('docusignaccept.resetSignedDocumentVariables', {
      call: async ({ req }, { set }) => {
        await set('docusignaccept.signedDocumentResponse', '');
        await set('docusignaccept.signedDocumentResponseError', '');
      }
    })

    .path('docusignaccept.docuSignURLResponse', variable(''))
    .path('docusignaccept.docuSignURLResponseError', variable(''))
    .path('docusignaccept.completeDocumentSignResponse', variable(''))
    .path('docusignaccept.completeDocumentSignResponseError', variable(''))
    .path('docusignaccept.completeDocumentSignResponseSuccess', variable(false))
    .path('docusignaccept.signedDocumentResponse', variable(''))
    .path('docusignaccept.signedDocumentResponseError', variable(''))
    .path('docusignaccept.errorMsg', variable(''))
    .path('docusignaccept.documentName', variable(''))
    .path('docusignaccept.signAction', variable(''))
    .path('docusignaccept.showDocusignModal', variable(false))
};